import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, ref} from "vue";
import {onBeforeRouteUpdate, } from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import PurchaseSaleReportComponent from "@/modules/Report/components/PurchaseSaleReportComponent.vue";




export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const _title = ref("Berichte")
const _spinner = useSpinner()


async function p_init() {
  _spinner.show()
  try {
  }
  finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: _title.value
  }, {
    default: _withCtx(() => [
      _createVNode(SogFlexRow, null, {
        default: _withCtx(() => [
          _createVNode(PurchaseSaleReportComponent)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})